/**
 * accountEvents — tiny in-process event bus for account data refresh signals.
 *
 * The polling hook emits events when a status change is detected.
 * UserAccountPage (or any component) listens and refreshes its local data.
 *
 * Events emitted:
 *   'deposits:refresh'    — deposit approved or rejected
 *   'withdrawals:refresh' — withdrawal paid
 *   'bets:refresh'        — bet won or lost
 *
 * Usage:
 *   import { accountEvents } from './accountEvents';
 *
 *   // Emit
 *   accountEvents.emit('deposits:refresh');
 *
 *   // Listen
 *   useEffect(() => {
 *     const unsub = accountEvents.on('deposits:refresh', () => loadDeposits());
 *     return unsub;
 *   }, []);
 */

class AccountEventBus {
  constructor() {
    this._listeners = {};
  }

  on(event, handler) {
    if (!this._listeners[event]) this._listeners[event] = new Set();
    this._listeners[event].add(handler);
    // Return unsubscribe function
    return () => this._listeners[event]?.delete(handler);
  }

  emit(event) {
    this._listeners[event]?.forEach((fn) => {
      try { fn(); } catch (e) { console.error('[accountEvents]', e); }
    });
  }
}

export const accountEvents = new AccountEventBus();
